import React, { useCallback, useEffect, useState } from 'react';
import {isArray} from "lodash";
import {
    ACard,
    ADataGrid,
    ADataGridColors,
    ADataGridColumn,
    ADataGridFilter,
    PagedSearchParams
} from "@atiautomacao/ati-ui-library";
import Delete from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelOutlined from "@mui/icons-material/Cancel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import Typography from '@mui/material/Typography';
import {extractFiltersFromColumns} from "../../../../Utils/DataUitils";
import {RootState} from "../../../../Config/Store";
import {useAppSelector} from "../../../../Config/Hooks";
import {DateFormat} from "../../../../Utils/DateFormatPatternUtils";
import {handleOnColor} from "../../../../Utils/AlarmsService";
import {Alarm} from "../../../Dashboard/Alarms/AlarmReducer";
import {useTheme} from "@mui/material";

export const initColumnsData = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'severityName',
        label: 'severidade',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'description',
        label: 'descrição',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'macroRegionName',
        label: 'macro',
        align: 'left',
        minWidth: 10,
        visibility: false,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'regionName',
        label: 'região',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'powerStationName',
        label: 'usina',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'skidName',
        label: 'skid',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'equipmentName',
        label: 'equipamento',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'dateTime',
        label: 'início',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "dateTime",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'clearDate',
        label: 'finalizado',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "clearDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'acknowledgementDate',
        label: 'reconhecido',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "acknowledgementDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'userName',
        label: 'usuário',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
] as ADataGridColumn[]

export type ActionConfig = {
    actionName: string;
};

export type AlarmRow = {
    id: string;
    selected?: boolean;
    teleObjectId: number;
    severityId: number;
    severityName: string;
    severityColor: string;
    description: string;
    macroRegionName: string;
    regionName: string;
    powerStationId: number;
    powerStationName: string | JSX.Element;
    skidId: number;
    skidName: string | JSX.Element;
    equipmentId: number;
    equipmentName: string;
    clearDate?: Date | string;
    acknowledgementDate?: Date | string;
    dateTime: Date | string;
    userName: string;
    group: boolean | any;
    actionsConfig?: Array<ActionConfig>;
}

export type TicketAlarmsProps = {
    alarm: Alarm | null;
    ticketAlarms: Array<Alarm>;
    isTicketClosed: boolean,
    handleChangeAlarms: Function;
};

export default function TicketAlarms({alarm: alarmOwner, ticketAlarms: ticketAlarmsOwner, isTicketClosed, handleChangeAlarms}: TicketAlarmsProps) {
    const theme = useTheme();
    const [rows, setRows] = useState<Array<AlarmRow>>([]);
    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumnsData), 0, 100));
    const [totalOfRecords] = useState(0);
    const [ticketAlarms, setTicketAlarms] = useState<Array<Alarm>>(new Array());
    const entities: Array<Alarm> = useAppSelector((state: RootState) => state.alarmOverview.entities);
    const [openAlarmsModal, setOpenAlarmsModal] = useState<boolean>(false);

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        let newPageParams: PagedSearchParams = new PagedSearchParams(dataGridFilters, page, pageSize);
        setPagedSearchParams(
            newPageParams
        );
    }, []);

    const structureRow = (entitiesValues: Array<Alarm>) => {
        let entity: Array<AlarmRow> = []
        const filterIds = ticketAlarms?.map((alarm) => Number(alarm.id));
        const alarmFilter = (alarm: Alarm) => (filterIds.indexOf(alarm.id) === -1) && (alarmOwner === null || alarmOwner.powerStationId === alarm.powerStationId);
        entitiesValues.filter(alarmFilter).forEach( alarm => {
            entity.push({
                teleObjectId: alarm.teleObjectId,
                selected: false,
                id: alarm.id.toString(),
                group: alarm.group,
                severityId: alarm.severityId,
                severityName: alarm.severityName,
                severityColor: alarm.severityColor,
                description: alarm.description,
                macroRegionName: alarm.macroRegionName,
                regionName: alarm.regionName,
                powerStationId: alarm.powerStationId,
                powerStationName: alarm.powerStationName,
                skidId: alarm.skidId,
                skidName: alarm.skidName,
                equipmentId: alarm.equipmentId,
                equipmentName: alarm.equipmentName,
                clearDate: alarm.clearDate ? DateFormat(alarm.clearDate) : "",
                acknowledgementDate: alarm.acknowledgementDate ? DateFormat(alarm.acknowledgementDate) : "",
                dateTime: DateFormat(alarm.dateTime),
                userName: alarm.userName,
                actionsConfig: [
                    {actionName: "select"}
                ]
            });
        });
        setRows(entity);
    }

    useEffect(() => setTicketAlarms(ticketAlarmsOwner), [ticketAlarmsOwner]);

    useEffect(() => {
        if (isArray(entities) && entities.length > 0) {
            structureRow(entities);
        } else {
            setRows([]);
        }
    }, [entities, ticketAlarms]);

    const handleAdd = (data: any) => {
        if (ticketAlarms.map(el => el.id).indexOf(data.id) === - 1) {
            const alarms = [
                ...ticketAlarms,
                data
            ];
            setTicketAlarms(alarms);
            handleChangeAlarms(alarms);
        }
    };

    const isDisableRemove = (item: any) => ((alarmOwner !== null) && (Number(alarmOwner.id) === item.id));

    const handleRemove = (data: any) => {
        const alarms = ticketAlarms.filter(alarm => alarm.id !== data.id);
        setTicketAlarms(alarms);
        handleChangeAlarms(alarms);
    };

    const newHandleOnColor = (data: any, columnItem: any): ADataGridColors => {
        return handleOnColor(data,columnItem,theme);
    }

    const handleAlarmsModalClose = () => setOpenAlarmsModal(!openAlarmsModal);

    return (
        <>
        <Button
            variant="contained"
            size="small"
            sx={{ marginBottom: 2 }}
            onClick={() => { if (!isTicketClosed) setOpenAlarmsModal(true); }}
            disabled={isTicketClosed}
        >
            Selecione Alarme
        </Button>
        <Grid container spacing={2}>
            {(ticketAlarms.length > 0) ? ticketAlarms.map((alarm, index) => (
                <Grid item key={alarm.id}>
                    <Card sx={{
                        width: 450,
                        borderRadius: 2,
                        boxShadow: 2
                    }}>
                        <CardHeader
                            title={
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    height: '34px',
                                }}>
                                    <Typography sx={{
                                            fontSize: 14,
                                            marginRight: 2,
                                            marginBottom: 0,
                                        }}
                                        color="text.secondary"
                                        gutterBottom
                                    >
                                        {alarm.description}
                                    </Typography>

                                    {/* Botão para excluir alarme */}
                                    { isTicketClosed || (alarmOwner && alarmOwner.id === alarm.id) ? '' : (
                                    <IconButton 
                                        name="remove"
                                        size={"small"}
                                        aria-label="Remover"
                                        onClick={() => handleRemove(alarm)}
                                    >
                                        <Tooltip title="Remover">
                                            <Delete />
                                        </Tooltip>
                                    </IconButton>
                                    )}
                                </Box>
                            }
                        />
                        <CardContent sx={{
                            paddingTop: 0
                        }}>
                            <Grid container>
                                <Grid item md={6} xs={12}>
                                    <Typography variant="caption" color="text.secondary">
                                        <b>Severidade:</b> {alarm.severityName}
                                    </Typography>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography variant="caption" color="text.secondary">
                                        <b>Usina:</b> {alarm.powerStationName}
                                    </Typography>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography variant="caption" color="text.secondary">
                                        <b>Skid:</b> {alarm.skidName}
                                    </Typography>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography variant="caption" color="text.secondary">
                                        <b>Equipament:</b> {alarm.equipmentName}
                                    </Typography>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography variant="caption" color="text.secondary">
                                        <b>Inicio:</b> {alarm.dateTime}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            )) : (
                <Grid item>Nenhum alarme selecionado</Grid>
            )}
        </Grid>

        <Modal
            open={openAlarmsModal}
            onClose={() => handleAlarmsModalClose()}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Card sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                height: '80%',
                borderRadius: '8px',
                boxShadow: 24,
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
            }}>
                <CardHeader
                    sx={{ paddingBottom: 0 }}
                    title={
                        <Typography variant="h6" component="div">
                            Selecione o Alarme
                        </Typography>
                    }
                />
                <CardContent sx={{
                    paddingTop: 0
                }}>
                    <ACard>
                        <ADataGrid
                            hideFilters={false}
                            showFilterOptions={false}
                            hideSelection={true}
                            size={"small"}
                            columns={initColumnsData}
                            rows={rows}
                            page={pagedSearchParams.page}
                            loading={false}
                            totalOfRecords={totalOfRecords || 0}
                            rowsPerPage={pagedSearchParams.size}
                            onFiltersChange={handleOnFiltersChange}
                            onColorSelect={newHandleOnColor}
                            actionColumnWidth={80}
                            disableActionsHeaderIcons={false}
                            actions={
                                <>
                                    <span></span>
                                    <IconButton {...({ disableHeader: true } as any)} name="select" size={"small"} aria-label="Select" onClick={handleAdd}>
                                        <Tooltip title="Selecionar">
                                            <AddCircleIcon />
                                        </Tooltip>
                                    </IconButton>
                                </>
                            }
                        />
                    </ACard>
                </CardContent>
                <CardActions sx={{
                    position: 'sticky',
                    bottom: 0,
                    padding: 2,
                    justifyContent: 'flex-end'
                }}>
                    <Button
                        size={"small"}
                        variant="contained"
                        onClick={() => handleAlarmsModalClose()}
                        endIcon={<CancelOutlined />}
                        style={{marginLeft: 5}}
                    >
                        Fechar
                    </Button>
                </CardActions>
            </Card>
        </Modal>
        </>
    );
}